import { publishEvent, SubscriptionType } from '@uma/react-commons/dist/index';
import React from 'react';
import { useDependencyManagerContext } from 'src/contexts/dependencyManager';
import {
  ShipmentHistoryInstantInkHyperLinkClicked,
  ShipmentHistoryAllInHyperLinkClicked
} from 'src/utils/analytics';
import { URLS } from 'src/utils/urls';
import { Link } from 'src/styles/styles';
import { SubscriptionsProps } from 'src/components/SubscriptionsCard/types';

const ShipmentHistoryLink = ({
  subscription,
  resourceId
}: {
  subscription: SubscriptionsProps;
  resourceId: string;
}) => {
  const { translate } = useDependencyManagerContext();
  const { type, startDate } = subscription || {};
  const isInstantInk = type === SubscriptionType.INSTANT_INK;
  const shipmentUrl = isInstantInk ? URLS.InkShipment : URLS.AllInShipment;
  const shipmentEvent = isInstantInk
    ? ShipmentHistoryInstantInkHyperLinkClicked(resourceId, startDate || '')
    : ShipmentHistoryAllInHyperLinkClicked(resourceId, startDate || '');

  return (
    <div className="caption">
      <Link
        data-testid="ShipmentHistoryLink"
        href={shipmentUrl}
        target="_blank"
        rel="noreferrer"
        onClick={() => publishEvent(shipmentEvent)}
      >
        {`${translate('subscriptions.shipmentHistory', 'Shipment history')}`}
      </Link>
    </div>
  );
};

export default ShipmentHistoryLink;
